import { Calendar, RefreshCw, AlertTriangle, ShieldCheck, MoreHorizontal } from 'lucide-react';

export default function UpcomingEvents() {
  const events = [
    { id: 1, title: 'Renovação de Contrato', company: 'TechCorp S.A', date: 'Hoje', type: 'renewal', icon: RefreshCw, color: 'text-blue-600', bg: 'bg-blue-50' },
    { id: 2, title: 'Expiração de SSL', company: 'E-commerce B2B', date: 'Amanhã', type: 'alert', icon: AlertTriangle, color: 'text-rose-600', bg: 'bg-rose-50' },
    { id: 3, title: 'Backup Agendado', company: 'Todas as empresas', date: 'Sex, 23:00', type: 'backup', icon: ShieldCheck, color: 'text-emerald-600', bg: 'bg-emerald-50' },
  ];

  return (
    <div className="bg-[#F8FAFC]/40 backdrop-blur-md border border-white rounded-[40px] p-8 shadow-[0_20px_60px_rgba(0,0,0,0.05)] relative overflow-hidden group h-fit">
      <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-50/10 rounded-full blur-3xl pointer-events-none group-hover:bg-indigo-50/20 transition-colors duration-700" />
      
      <div className="flex justify-between items-center mb-6 relative z-10">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-white border border-slate-100 text-slate-900 flex items-center justify-center shadow-sm group-hover:border-indigo-100 transition-colors">
            <Calendar size={18} className="text-indigo-600" />
          </div>
          <div className="flex flex-col">
            <span className="text-[10px] font-black uppercase text-slate-400 tracking-[0.2em] mb-1 leading-none">Cronograma</span>
            <h3 className="text-sm font-display font-black text-slate-800 tracking-tight leading-none">Próximos Eventos</h3>
          </div>
        </div>
        <button className="p-2 rounded-full hover:bg-white text-slate-400 transition-colors shadow-sm">
          <MoreHorizontal size={16} />
        </button>
      </div>

      <div className="flex flex-col gap-3 relative z-10">
        {events.map(event => (
          <div key={event.id} className="flex items-center gap-4 p-4 rounded-[20px] border border-slate-50 bg-white/60 backdrop-blur-sm hover:border-indigo-100 hover:shadow-md transition-all cursor-default group/item">
            <div className={`w-9 h-9 rounded-full ${event.bg} flex items-center justify-center shrink-0 group-hover/item:scale-110 transition-transform duration-300`}>
              <event.icon size={16} className={event.color} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex justify-between items-center mb-0.5">
                <p className="text-xs font-black text-slate-800 truncate pr-2">{event.title}</p>
                <span className={`text-[8px] font-black uppercase tracking-widest px-2 py-0.5 rounded-md whitespace-nowrap ${
                  event.date === 'Hoje' ? 'bg-rose-50 text-rose-600 border border-rose-100' : 'bg-slate-50 text-slate-600 border border-slate-100'
                }`}>
                  {event.date}
                </span>
              </div>
              <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider truncate">{event.company}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
